<template>
  <div class="">
    <el-container>
      <el-main>
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-input v-model.trim="queryParams.iccid" placeholder="请输入卡号" />
          </el-form-item>
          <el-form-item>
            <el-input v-model.trim="queryParams.ordNo" placeholder="订单号/微信订单号" />
          </el-form-item>
          <el-form-item>
            <el-select  clearable filterable remote allow-create default-first-option v-model="queryParams.status" placeholder="订单状态">
              <el-option label="已支付" :value="1"></el-option>
              <el-option label="已到账" :value="2"></el-option>
              <el-option label="退订" :value="3"></el-option>
              <el-option label="接口订购" :value="55"></el-option>
            </el-select>
          </el-form-item>

            <el-form-item v-show="isShow">
              <el-select @focus="loadAgent" clearable filterable remote allow-create default-first-option v-model="queryParams.agentId" placeholder="请选择代理商">
                <el-option v-for="i in agents" :key="i.id" :label="i.agentName" :value="i.agentId">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="isShow">
              <el-select clearable filterable remote allow-create default-first-option v-model="queryParams.agentBe" placeholder="代理商所属">
                <el-option :value="0" label="代理商直属卡"></el-option>
                <el-option :value="1" label="代理商所有卡"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="isShow">
              <el-select @focus="loadType" clearable filterable allow-create default-first-option v-model="queryParams.packetId" placeholder="请选择资源类型">
                <el-option v-for="(i,index) in cardTypes" :key="index" :label="i.cardTypeName" :value="i.cardTypeCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-show="isShow">
              <el-input v-model.trim="queryParams.ordName" placeholder="请输入交易名称" />
            </el-form-item>
            <el-form-item v-show="isShow">
              <el-input v-model.trim="queryParams.packetName" placeholder="请输入套餐包名称"></el-input>
            </el-form-item>
            <el-form-item v-show="isShow">
              <el-date-picker style="padding-left:3px" v-model="queryParams.startTime" type="datetime" placeholder="选择开始时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item v-show="isShow">
              <el-date-picker v-model="queryParams.endTime" type="datetime" placeholder="选择结束时间" @change="dataSearchEd" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>

          <el-form-item>
            <el-button size="small" plain @click="list(1)" type="primary" icon="el-icon-search">搜索</el-button>

            <el-button size="small" plain @click="exportExcel" type="primary" icon="el-icon-download">导出</el-button>

            <!--<el-button v-if="roleId==='777' || roleId==='619285375'" size="small" plain @click="dialogVisible = true" type="primary" icon="el-icon-edit">批量退款</el-button>-->

          </el-form-item>
          <el-form-item>
            <el-button style="padding-left: 10px;" @click="showToggle" type="primary" size="small" plain>
              {{btnText}}
            </el-button>
          </el-form-item>
        </el-form>


        <el-table
                    ref="multipleTable"
                   :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                   :cell-style="{height:'5px,0',textAlign:'center'}"
                   :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                   border style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column width="200" prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column prop="iccid" label="iccid" width="200">
          </el-table-column>
          <el-table-column  label="姓名" width="130" v-if="roleId==='777' || roleId==='619285375'">
            <template slot-scope="scope">
              <span style="color: #409EFF;">{{scope.row.realName}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="手机号" width="130" v-if="roleId==='777' || roleId==='619285375'">
            <template slot-scope="scope">
              <span style="color: #409EFF;" v-if="scope.row.mobile!=null"><i class="el-icon-mobile"></i>{{scope.row.mobile}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="身份证号" width="180" v-if="roleId==='777' || roleId==='619285375'">
            <template slot-scope="scope">
              <span style="color: #409EFF;" v-if="scope.row.idCardNo!=null"><i class="el-icon-bank-card"></i>{{scope.row.idCardNo}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ordNo" label="订单号" width="220">
          </el-table-column>
          <el-table-column prop="agentName" label="代理商" width="120">
          </el-table-column>
          <!--<el-table-column prop="createUser" label="业务员" width="120">
          </el-table-column>-->

          <el-table-column prop="ordName" label="交易名称" width="160">
          </el-table-column>
          <el-table-column prop="price" label="交易金额" width="100">
          </el-table-column>
          <el-table-column prop="givePrice" label="赠送金额" width="100">
          </el-table-column>
          <el-table-column prop="couponName" label="赠送/核销劵" width="100">
          </el-table-column>
          <!--<el-table-column prop="account" label="交易后金额" width="100">
          </el-table-column>-->
          <el-table-column prop="packetName" show-overflow-tooltip label="套餐包名称" width="200">
          </el-table-column>
          <el-table-column prop="packetFlow" label="套餐规格" width="120">
          </el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status===0">未支付</div>
              <div v-if="scope.row.status===1">支付成功</div>
              <div v-if="scope.row.status===2">加包成功</div>
              <div v-if="scope.row.status===3">退订</div>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付方式" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.payType==='w'">微信支付</div>
              <div v-if="scope.row.payType==='b'">余额成功</div>
            </template>
          </el-table-column>
          <el-table-column prop="validateType" label="生效类型" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.validateType==='month'">当月包</div>
              <div v-if="scope.row.validateType==='next'">次月包</div>
            </template>
          </el-table-column>
          <el-table-column min-width="220" prop="info" label="备注信息">
            <template #default="scope">
              <el-tooltip :content="scope.row.info" raw-content placement="top-start" v-if="scope.row.info">
                <span v-if="scope.row.info && scope.row.info.length <= 10">
                  {{scope.row.info}}
                </span>
                <span v-if="scope.row.info&& scope.row.info.length > 10">
                  {{scope.row.info.substr(0, 10) + "..."}}
                </span>
              </el-tooltip>
              <span v-else-if="scope.row.info== null"> 无 </span>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="outTime" label="出卡时间">
          </el-table-column>

          <el-table-column fixed="right" label="操作" min-width="100" v-if="roleId==='777' || roleId==='619285375'">
            <template slot-scope="scope">
              <el-button  v-if="scope.row.ordNo.indexOf('free')!==-1" type="primary" size="small" plain @click="express(scope.row)">发货
              </el-button>
              <div v-if="scope.row.refundState===0 || scope.row.refundState===null||scope.row.refundState===''">
                <el-button v-if="scope.row.payType==='w' || scope.row.payType==='b' || scope.row.payType==='r'" @click="reapplyRefund(scope.row,scope.$index)" style="color: red" type="text" size="small" plain  >申请退款
                </el-button>
              </div>
              <div v-else-if="scope.row.refundState===1">
                <el-button @click="saerefundinfo(scope.row)" style="color: rgba(0,0,0,0.64)" type="text" size="small" plain  >退款处理中
                </el-button>
              </div>
              <div v-else-if="scope.row.refundState===2">
                <el-button style="color: rgba(0,0,0,0.64)" type="text" size="small" plain  >已退款
                </el-button>
              </div>
              <div>
                <el-button @click="addServiceProcess(scope.row,'删除订单')"style="color: #409EFF" type="text" size="small" plain  >删除订单
                </el-button>
              </div>

            </template>
          </el-table-column>

        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>

    <el-dialog center with="30%" :close-on-click-modal="false" title="退款申请单" :visible.sync="reapplyRefundDis">
      <el-form label-width="120px" inline :model="reapplyRefundData" ref="reapplyRefundData">
        <el-form-item  label="ICCID">
          <el-input disabled v-model="reapplyRefundData.iccid" style="color:#000000;"/>
        </el-form-item>
        <el-form-item label="下单客户">
          <el-input disabled v-model="reapplyRefundData.realName"/>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input disabled v-model="reapplyRefundData.ordNo"/>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-input disabled v-model="reapplyRefundData.createTime"/>
          <div style="color: red">
            注意：超过一年的订单不可退款
          </div>
        </el-form-item>
        <el-form-item label="交易金额">
          <el-input disabled v-model="reapplyRefundData.price" style="color:#000000;"/>
        </el-form-item>
        <el-form-item prop="backPrice" label="退款金额" :rules="[
                {required: true,message:'请输入退款金额',trigger:'blur'}
        ]">
          <el-input maxlength="8" type="number"  v-model="reapplyRefundData.backPrice"/>
        </el-form-item>
        <el-form-item style="width: 100%;"  prop="reason" label="退款原因" :rules="[
                {required: true,message:'请输入退款原因',trigger:'blur'}
        ]">
          <el-input :rows="5" style="width: 505px" type="textarea"  v-model="reapplyRefundData.reason"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="reapplyRefundDis = false">取 消</el-button>
        <el-button type="primary" @click="toReapplyRefund(reapplyRefundData)">申请退款</el-button>
      </div>
    </el-dialog>

    <!--<el-dialog width="30%" title="批量退款上传（模板内容不可添加或删减）" :visible.sync="dialogVisible">
      <el-card style="margin-top: -5%">
        <p style="color: red">温馨提示：为明确退款规则和规范退款流程，请退款用户详细阅读该协议。</p>
        <p style="line-height: 0.5rem">1、退款用户需填写必要信息才能提交退款申请;</p>
        <p style="line-height: 0.5rem">2、退款金额会以表格中填入的金额进行退款处理</p>
        <p style="line-height: 0.5rem">3、仅可退订一年以内的微信订单</p>
        <p style="line-height: 0.5rem">4、模板下载：
          <a style="color: #3698eb;cursor: pointer" :href="importUrl">点击此处</a></p>
      </el-card>
      <el-upload :disabled="false" ref="upload" style="text-align: center;margin-top: 3%" class="upload-demo" drag
                 :action="uploadUrl" multiple :headers="headers"
                 :auto-upload="false"  :before-upload="this.$upload.beforeUpload"
                 :on-exceed="this.$upload.onExcced" :on-success="this.$upload.onSuccess" :on-change="onChange"
                 :on-error="this.$upload.onError" >
        <i class="el-icon-upload"></i>
        <div class="el-upload__tip">只能上传xls/xlsx文件</div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div style="text-align: center;margin-top: 2%">
        <el-button style="text-align: center" size="small" type="primary" @click="uploadFile">确定上传</el-button>
        <el-button style="text-align: center" size="small" type="info" @click="cancel">取消</el-button>
      </div>


      &lt;!&ndash;<el-upload class="upload-demo" ref="upload" :action="importExcelUrl" accept=".xlsx" width="30%" :before-upload="beforeUploadFile" :auto-upload="false" v-loading="loading" :on-success="uploadSuccess">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      </el-upload>
      <span>下载模板：<a :href="importUrl">点击下载</a></span>&ndash;&gt;
    </el-dialog>-->

    <el-dialog :close-on-click-modal="false"  title="物流发货" :visible.sync="expressShow" class="class_dialog_hospital" width="40%">
      <el-form  :label-position="labelPosition" label-width="150px" :model="expressForm" ref="expressForm">
        <el-form-item  label="订单号">
          <el-input disabled v-model.trim="expressForm.ordNo"/>
        </el-form-item>
        <el-form-item  label="发货状态">
          <el-radio-group  disabled v-model="expressForm.expressStatus">
            <el-radio :label="0">待发货</el-radio>
            <el-radio :label="1">已发货</el-radio>
            <el-radio :label="2">已退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收货地址">
          <el-input disabled v-model.trim="expressForm.addressPlace+'--'+expressForm.addressName+'--'+expressForm.addressMobile"/>
        </el-form-item>
        <el-form-item disabled label="商品规格">
          <el-input  v-model.trim="expressForm.selectParam"/>
        </el-form-item>
        <el-form-item  label="快递名称">
          <el-input  v-model.trim="expressForm.express"/>
        </el-form-item>
        <el-form-item  label="快递单号">
          <el-input  v-model.trim="expressForm.expressNumber"/>
        </el-form-item>
        <el-form-item  label="设备号">
          <el-input  v-model.trim="expressForm.iccid"/>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="info" plain @click="expressShow = false">取 消</el-button>
        <el-button size="small" v-if="expressForm.expressStatus===0" type="primary" plain @click="addExpress('expressForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'sysSucOrder',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.queryParams.indexType=_this.$route.query.type
    _this.headers={
      token: sessionStorage.getItem("sys-token"),
      userId: sessionStorage.getItem("loginUser")!==null?JSON.parse(sessionStorage.getItem("loginUser")).id:''
    }
    _this.list(1)

  },

  data() {
    return {
      reapplyRefundDis: false,
      reapplyRefundData:{},
      headers:{},
      fileList:[],
      uploadHeaders:{},
      uploadUrl: process.env.VUE_APP_SERVER + '/manager/order/batchRefund',
      importUrl: 'http://admin.zs2020iot.cn/refund.xlsx',
      dialogVisible: false,
      roleId: this.$loginUser.roleId,
      maxHeight: 500,
      ordName: '',
      createUser: '',
      agentBe: '',
      oneCardType: '',
      agents: [],
      agent: '',
      ordType: '',
      payType: '',
      agentId: '',
      parentId: '',
      validateType: '',
      dialogFormVisible: false,
      multipleSelection: [],
      options: [],
      cardTypes: [],
      cardType: '',
      tableData: [],
      inputNum: '',
      packetName: '',
      inputNumber: '',
      cards: {},
      type: '',
      isDisabled: true,
      cardTypeList: [],
      iccids: '',
      status: '',
      isShow: true,
      btnText: '',
      queryParams:{
        currentPage:1,
        pageSize: 10,
        iccid:'',
        agentId:'',
        packetId:'',
        ordName:'',
        ordNo:'',
        packetName:'',
        createTime:'',
        startTime: '',
        endTime: '',
        status:'',
        agentBe:'',
        indexType:'',
      },
      orderJs: require('../../../api/order'),
      cardTypeJs: require('../../../api/cardType'),
      agentJs: require('../../../api/agent'),
      serviceProcessjs: require("../../../api/serviceProcess"),
      loading: false,
      expressShow:false,
      labelPosition: 'right',
      expressForm: {
        iccid:'',
        ordNo: '',
        expressStatus: '',
        express: '',
        expressNumber: '',
        addressName: '',
        addressMobile: '',
        addressPlace: '',
        orderName: '',
        selectParam:'',
      },
      index: -1,
    }
  },
  created() {
    this.showToggle()
  },
  methods: {
    addServiceProcess(row,operationName){
      let _this = this
      _this.$confirm('请确定是否'+operationName+'？执行此操作删除相对应套餐及返佣。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data={
          ordNo: row.ordNo,
          operationName:operationName
        }
        _this.serviceProcessjs.addServiceProcess(data)
                .then(res => {
                  _this.$alert('已操作，请等待审核！')
                })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消！'
        })
      })
    },
    saerefundinfo(row){
      this.$confirm('前去退款列表查看详情, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          path: '/system/sysRefundOrderList',
          params:{
            ordNo: row.ordNo
          }
        })
      }).catch(() => {

      });
    },
    toReapplyRefund(data){
      let _this = this

      _this.$ajax.post('/manager/order/applyRefund',data)
              .then(response => {
                if(response.data.code==='0'){
                  _this.$alert(response.data.data)
                  this.reapplyRefundDis = false
                }else{
                  _this.$alert(response.data.msg)
                  this.reapplyRefundDis = false
                }
                this.tableData[this.index].refundState=1

              })
    },
    reapplyRefund(row,index){
      this.reapplyRefundData = row
      this.index = index
      this.reapplyRefundDis= true
    },
    onChange(file,list){
      let that=this
      if(null!=file){
        let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (extension !== 'xlsx' && extension !== 'xls') {
          that.$alert('只能上传Excel的文件','失败')
          return false
        }
        that.fileList.push(file)
      }

    },
    cancel(){
      let that=this
      that.dialogVisible = false
      that.$refs.upload.clearFiles()
    },
    uploadFile() {
      let that =this
      if(that.fileList.length===0){
        that.$alert("请选择上传文件")
        return false
      }
      that.$refs.upload.submit()
      that.$alert("上传退款订单成功")
      that.dialogVisible=false
    },
    express(row){
      let _this = this
      _this.expressForm = row
      _this.expressShow=true
    },
    addExpress(fromName){
      let _this = this
      _this.$refs[fromName].validate(valid => {
        _this.orderJs.addExpress(_this.expressForm).then(response => {
          if(response.data.code==='0'){
            this.$alert(response.data.data)
          }else{
            _this.$alert(response.data.msg)
          }
        })
      })
    },
    loadAgent(){
      this.agents =[]
      this.agentJs.getSearchAgent(
              {}).then(res=>{
        res.data.data.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agents.push(map)
        })

      })
    },
    showToggle() {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.btnText = '更多'
      } else {
        this.btnText = '更多'
      }
    },
    dataSearchSt(data) {
      this.startTime=data
    },
    dataSearchEd(data) {
      this.endTime=data
    },

    loadType() {
      let _this = this
      _this.cardTypes=[]
      _this.cardTypeJs.getCardTypeList().then(response => {
        _this.cardTypes = response.data.data
      })
    },

    exportExcel() {
      let _this = this
      _this
        .$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {

          _this.orderJs.importOrderList(_this.queryParams)
            .then(res => {
              if(res.data.code==='0'){
                _this.$alert("已成功导出，请到任务管理处下载")
              }else{
                _this.$alert(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          })
        })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    list(page) {
      let _this = this
      _this.loading=true
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      if (_this.selectDatetimeed === null) {
        _this.selectDatetimeed = ''
      }
      if (_this.selectDatetimest === null) {
        _this.selectDatetimest = ''
      }
      _this.queryParams.current = page
      _this.queryParams.size =_this.$refs.pagination.size
      _this.queryParams.url ='sysSuc'
      _this.orderJs.getOrderList(_this.queryParams)
        .then(response => {
          if(response.data.code==='0'){
            _this.loading=false
            _this.tableData = response.data.data.rows
            _this.$refs.pagination.render(page, response.data.data.total)
          }else{
            _this.loading=false
            _this.tableData=[]
          }
        }).catch(err=>{
        _this.loading=false
      })
    }
  }
}
</script>

<style lang="less" scoped>

  ::v-deep .el-dialog{
    width: 40%;
  }

  ::v-deep .el-table__fixed-body-wrapper{
    height: calc(100% - 48px ) !important;
  }

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }


._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
.el-input--small .el-input__inner {
  height: 32px;
  line-height: 3px !important;
}
</style>
<style scoped>
/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}

</style>